<template>
  <a-row>
    <a-col :xxl="8" :xl="9" :lg="12" :md="8" :xs="24">
      <Aside :class="{ 'assessment-bg': isAssessmentRoute }">
        <div class="auth-side-content">
          <Content>
            <img
              :style="{ width: '300px' }"
              :src="require('@/static/img/logo_white.png')"
              alt="PLN Energi Primer Indonesia"
            />
            <br />
            <br />
            <sdHeading as="h1"> </sdHeading>
          </Content>
        </div>
      </Aside>
    </a-col>
    <a-col :xxl="16" :xl="15" :lg="12" :md="16" :xs="24">
      <router-view></router-view>
    </a-col>
  </a-row>
</template>
<script>
import { Aside, Content } from './style';

const AuthLayout = {
  name: 'AuthLayout',
  components: { Aside, Content },
  computed: {
    isAssessmentRoute() {
      return this.$route.path.startsWith('/auth-assessment');
    },
  },
};

export default AuthLayout;
</script>
